
















import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import {Mixin} from "@/mixins";

@Component({
    name: "Modal",
})
export default class Modal extends Mixins(Mixin) {
    @Prop()
    title!: string;
}
